import type { Control, FieldValues } from 'react-hook-form';
import { isCheckboxChangeEventType } from '../../dynamic-form/dynamic-form-common';
import OdinController from '../../dynamic-form/odin-controller.component';
import type { CheckboxChangeEventType, CheckboxProps } from './checkbox.component';
import Checkbox from './checkbox.component';

export interface HfCheckboxProps extends CheckboxProps {
  control: Control<FieldValues>;
  name: string;
}

export default function HfCheckbox({
  control,
  label,
  name,
  value,
  readOnly,
  required,
  useAnimation,
  onChange,
  fieldValueConverter,
  disabled,
  labelStyles,
}: HfCheckboxProps) {
  const checkboxValue = value;

  return (
    <OdinController
      name={name}
      control={control}
      onChange={onChange}
      fieldValueConverter={fieldValueConverter}
      render={({ field: { onChange, value }, fieldState: { error } }) => {
        const checkedValue =
          typeof value === 'boolean'
            ? value
            : isCheckboxChangeEventType(value)
              ? (value as CheckboxChangeEventType).checked
              : false;

        return (
          <Checkbox
            name={name}
            label={label}
            value={checkboxValue}
            initialChecked={checkedValue}
            useAnimation={useAnimation}
            onChange={onChange}
            readOnly={readOnly}
            required={required}
            error={error?.message}
            disabled={disabled}
            labelStyles={labelStyles}
          />
        );
      }}
    />
  );
}
